import React, { useEffect, Suspense } from 'react'
import StepWizard from 'react-step-wizard'
import { Grid } from '@material-ui/core'
import { useForm } from '../../../context/formContext'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import ElegibilidadSec1 from './ElegibilidadSec1'
import ElegibilidadSec2 from './ElegibilidadSec2'
import ElegibilidadSec3 from './ElegibilidadSec3'
import ElegibilidadSec4 from './ElegibilidadSec4'
import ElegibilidadSec5 from './ElegibilidadSec5'
import ElegibilidadSec6 from './ElegibilidadSec6'
import { useEligibility } from '../../../context/EligibilityContext'

const ElegibilidadForm = () => {
  const { setFetchRequest } = useForm()
  const [state] = useEligibility()

  useEffect(() => {
    setFetchRequest(['create_form'])
  }, [])

  return (
    <>
      <div
        id="wizard-form"
        style={{
          overflow: 'hidden',
          backgroundColor: 'white',
          boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
        }}
      >
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">
                  Formulario Elegibilidad de Inversiones para Financiamiento
                </label>
              </div>
              <label className="formDescription">
                Rellene la información requerida para registrar el formulario
              </label>
            </Grid>
          </Grid>
          {/* <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>
            <Grid item>
              <div
                onClick={() => !loadingSave && saveFormElegibilidad()}
                data-tip
                data-for="savePop"
                style={{
                  backgroundColor: !loadingSave ? '#5cb85c' : 'gray',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <SaveIcon />
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Guardar Borrador</span>
              </ReactTooltip>
            </Grid>
          </Grid> */}
        </div>

        <Grid
          container
          spacing={1}
          style={{ marginTop: '18px', marginBottom: '36px' }}
        >
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 1
                ? `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 1</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 2
                ? `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 2</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 3
                ? `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 3</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 4
                ? `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 4</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 5
                ? `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 5</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 6
                ? `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 6</label>
          </Grid>
        </Grid>

        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '80%',
                height: '80vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <StepWizard initialStep={1}>
            <ElegibilidadSec1 />
            <ElegibilidadSec2 />
            <ElegibilidadSec3 />
            <ElegibilidadSec4 />
            <ElegibilidadSec5 />
            <ElegibilidadSec6 />
          </StepWizard>
        </Suspense>
      </div>
    </>
  )
}

export default ElegibilidadForm
